import { ValvurHttpError } from '../../../core/errors/valvur-http.error';

export function isIdentityLayerDisabledError(error: unknown): boolean {
  return (
    error instanceof ValvurHttpError &&
    error.errorCode === 'AUTH_IDENTITY_LAYER_DISABLED'
  );
}

export function isParentKycRequiredError(error: unknown): boolean {
  return (
    error instanceof ValvurHttpError &&
    error.errorCode === 'AUTH_IDENTITY_PARENT_KYC_REQUIRED'
  );
}
